import React from "react";
import "../styles/Legal.css";
import Footer from "../components/Footer";

const LegalHome = () => {
  return (
    <>
      <div className="legal-container">
        <h1 className="legal-title">Legal Center</h1>
        <p className="legal-date">Updated October 2025</p>

        <div className="legal-content">
          <p>
            Welcome to the <strong>CJet Dispatch Legal Center</strong>.  
            This section contains important legal information governing your use of our services,  
            including Terms & Conditions, Privacy Policy, and Refund Policy.  
            Please review each document carefully to understand your rights and responsibilities  
            when using our platform.
          </p>

          <h2>📜 Our Legal Documents</h2>
          <ul className="legal-list">
            <li>
              <a href="/terms" className="legal-link">
                Terms & Conditions
              </a>
              <p className="legal-summary">
                Defines the rules, obligations, and legal limitations for using CJet Dispatch’s
                courier and logistics platform.
              </p>
            </li>

            <li>
              <a href="/privacy" className="legal-link">
                Privacy Policy
              </a>
              <p className="legal-summary">
                Explains how we collect, use, protect, and share your personal and shipment data
                under NDPR (Nigeria) and CCPA (U.S.) compliance.
              </p>
            </li>

            <li>
              <a href="/refund" className="legal-link">
                Refund Policy
              </a>
              <p className="legal-summary">
                Outlines refund eligibility, dispute timelines, and how to resolve payment issues
                or failed transactions.
              </p>
            </li>
          </ul>

          <h2>📍 Contact Information</h2>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:support@cjetdispatch.com">support@cjetdispatch.com</a>
            <br />
            <strong>Website:</strong>{" "}
            <a href="https://cjetdispatch.com" target="_blank" rel="noreferrer">
              https://cjetdispatch.com
            </a>
            <br />
            <strong>Postal:</strong> 2nd House Beside Mopo Barrack, Ilorin, Kwara State, Nigeria
            <br />
            <strong>U.S. Office:</strong> 70 Tripp Dr, Talladega, AL 35160, United States
          </p>

          <p className="legal-footer">© 2025 CJet Dispatch LLC. All rights reserved.</p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default LegalHome;